import React from "react";

export default function ServerOnlyBanner() {
  return (
    <div
      className="alert alert-info mb-2"
      style={{ padding: "0.5rem 0.75rem", fontSize: "0.875rem" }}
      role="status"
    >
      <strong>Client analytics blocked.</strong> This user&apos;s browser is
      not sending client-side analytics, so this view uses server logs only.
      Logins, API requests and sessions are shown; page views are not
      available. Session length is a lower bound (first to last recorded
      request), and counts are estimates.
    </div>
  );
}
